import { Envio } from "../../firebase/firestore/envios";
import FormShipment from "../shipments/FormShipment";
import Modal from "./Modal";

export default function ModalFormShipment({
  entity,
  isOpen,
  onClose,
}: {
  entity: Envio;
  isOpen: boolean;
  onClose: () => void;
}) {
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="Editar envío"
      content={<FormShipment onClose={onClose} entity={entity} />}
    />
  );
}
